<template>
    <div v-show="visible">
        <el-dialog title="导入" :visible.sync="visible" :close-on-click-modal="false"  v-loading="loading" :before-close="dialogClose"  width="410px">    
            <el-form ref="form" :model="form" :rules="rules"  label-width="100px">
                <el-form-item   prop="deptId" label="绑定学校">
                    <el-select v-model="form.deptId" placeholder="请选择学校" style="width: 260px;" @change="getAttendaceGroup();getClassHours()">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item   prop="attendaceGroupId" label="绑定考勤组">
                    <el-select v-model="form.attendaceGroupId" style="width: 260px;" clearable placeholder="请选择">
                        <el-option
                            v-for="item in attendaceGroups"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>


                <el-form-item  prop="classHoursId" label="上课时间段">
                    <el-select v-model="form.classHoursId"  style="width: 260px;" collapse-tags clearable multiple placeholder="请选择">
                        <el-option
                        v-for="item in classHours"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                
                <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :show-file-list="false"
                    :auto-upload="true"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload">
                    <el-button size="small" type="primary">点击导入</el-button>&nbsp;&nbsp;
                    <div slot="tip" class="el-upload__tip" style="font-size:12px;color:#BBBBBB">
                        &nbsp;&nbsp;&nbsp;&nbsp;点击“导出数据”按钮，根据模板格式填写信息，然后再进行点击导入。
                    </div>
                </el-upload>
                <br/>
                <el-button size="small" type="info" @click="downLoad">导出数据</el-button>
            </el-form>
        </el-dialog> 
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                loading:false,
                fileList: [],
                uploadUrl:"",
                depts:[],
                attendaceGroups:[],
                classHours:[],
                form:{
                    deptId: undefined,
                    attendaceGroupId: undefined,
                    classHoursId: undefined
                },
                rules: {
                    deptId: [
                        { required: true, message: '请选择绑定学校', trigger: 'blur' }
                    ],
                    attendaceGroupId: [
                        { required: true, message: '请选择绑定考勤组', trigger: 'blur' }
                    ],
                    classHoursId: [
                        { required: true, message: '请选择上课时间段', trigger: 'blur' }
                    ]
                },
            }
        },
        created:function () {
        },
        methods:{
             init(){
                this.visible = true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.uploadUrl = this.setClassroomTimeImportUrl;
                // 初始学校数据
                this.getDepts();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            handleAvatarSuccess(res, file) {
                //this.imageUrl = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        let fileType = file.type
                        let isLt2M = file.size / 1024 / 1024 < 100
                        console.log("文件类型："+fileType+";文件大小："+file.size)
                        if(this.$constant.excelFileType.indexOf(fileType) == -1){
                            this.$commonFn.showTip('导入文件只支持.xls与.xlsx', 3)
                            return false
                        }

                        if (!isLt2M) {
                            this.$commonFn.showTip('文件大小不能超过100MB!', 3)
                            return false
                        }
                        // 上传文件
                        let uploadForm=new FormData()
                        uploadForm.append('file', file)
                        uploadForm.append('deptId', this.form.deptId)
                        uploadForm.append('attendaceGroupId', this.form.attendaceGroupId)
                        uploadForm.append('classHoursId', this.form.classHoursId.join(","))
                        // return;
                        this.loading=true
                        this.$axios.post(this.uploadUrl, uploadForm).then((res) => {
                            // console.log("文件反馈:"+JSON.stringify(res.data))
                            if(res.data.status == 200){
                                this.$commonFn.showTip(res.data.message, 4,true)
                                this.visible=false
                                this.$parent.getData()
                            }else{
                                this.$commonFn.showTip(res.data.message, 3)
                            }
                            this.loading=false
                        }, (err) => {
                            console.log(err)
                            this.loading=false
                            this.$commonFn.showTip("网络繁忙，请稍后重试，响应码("+err.response.status+")", 3)
                        });
                    }
                });
            },
            downLoad(){  
                this.loading=true;
                this.loadingText="正在导出中，请耐心等待";

                let url=this.setClassroomTimeExportUrl;
                let param = new URLSearchParams();
                param.append('deptId', this.form.deptId);
                
                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '设置班级策略.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    console.log(error); 
                    this.loading=false;
                });

            },
            getDepts(){ // 获取学校
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                           this.getAttendaceGroup();
                           this.getClassHours();
                        }
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            //获取考勤组
            getAttendaceGroup(){
                let url  = this.listAttendaceGroupDataUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    // console.log("考勤组:"+JSON.stringify(res.data))
                    if(res.status==200){
                      this.attendaceGroups = res.data; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            //获取上课时间
            getClassHours(){
                let url  = this.listClassHoursSelectUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    // console.log("上课时间列表:"+JSON.stringify(res.data))
                    if(res.status==200){
                      this.classHours = res.data.list; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/page/set/classroomtime/ImportClassRoomTime.vue